const NoPage = () => {
    return <h1 className="container" style={{textAlign: "center"}}>404 Nici-o pagina gasita</h1>;
  };
  
  export default NoPage;